
import React, { useContext } from 'react';
import { PhoneActionsContext } from './provider';


export function usePhoneActions() {
  const context = useContext(PhoneActionsContext);

  if (!context) throw new Error('usePhoneActions must be used within the PhoneActionsContext');

  return context;
}
